export const SET_DATA = 'user/SET_DATA';
export const SET_TOKEN = 'user/SET_TOKEN';
export const SET_USER = 'user/SET_USER';
export const INIT = 'user/INIT';
export const LOGOUT = 'user/LOGOUT';
export const SET_SNACK_BAR_DATA = 'user/SET_SNACK_BAR_DATA';
export const SET_SNACK_BAR_STATE = 'user/SET_SNACK_BAR_STATE';
export const SET_LOADING_STATE = 'user/SET_LOADING_STATE';
